import CardHeader from '@creator/ui/components/Card/CardHeader';
import { cn } from '@creator/ui/utils/ui';
import { usePost } from '@src/store/posts/hooks/usePost';
import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import React, { type FC, memo } from 'react';
import PostMenuPopover from '../PostMenuPopover/PostMenuPopover';
import PostBasicInfo, { type PostBasicInfoProps } from '../Upvote/PostBasicInfo/PostBasicInfo';

export interface PostCardHeaderProps {
    className?: string;
    postId: string;
    postBasicInfoProps?: Partial<PostBasicInfoProps>;
}

const PostCardHeader: FC<PostCardHeaderProps> = props => {
    const { postId, className } = props;

    const post = usePost(postId);

    const renderPostBasicInfo = () => {
        if (!post) return null;

        const infoProps: PostBasicInfoProps = {
            className: '',
            publisherName: post.publisherName,
            publisherProfileName: post.createdByWhitelistedUser ? post.publisherProfileName : '',
            publisherSlugUrl: post.publisherSlugUrl,
            createdAt: post.createdAt,
            tokenName: post.tokenName,
            showPartnerLabel: post.createdByWhitelistedUser,
        };

        return <PostBasicInfo {...infoProps} />;
    };

    const renderPostMenuPopover = () => {
        if (!post) return null;

        const _props = {
            className: 'absolute p-2 top-0 right-0',
            tokenName: post.tokenName,
            postId,
        };

        return <PostMenuPopover {..._props} />;
    };

    return (
        <CardHeader className={cn('relative', className)}>
            {renderPostMenuPopover()}
            {renderPostBasicInfo()}
        </CardHeader>
    );
};

export default memo(PostCardHeader, propsEqualityFn);
